var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIi2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.409 13.5982C11.4306 13.3862 11.3495 13.1765 11.1914 13.0336L9.57768 11.0899V10.7998H14.5875L18.4596 19.2923L21.8641 10.7998H26.64V11.0902L25.2606 12.4128C25.1416 12.5035 25.0828 12.6524 25.1074 12.8V22.5183C25.0828 22.6658 25.1416 22.8147 25.2606 22.9054L26.6078 24.228V24.5185H19.8314V24.228L21.2271 22.8732C21.3643 22.736 21.3643 22.6958 21.3643 22.4861V14.6306L17.4836 24.4859H16.9592L12.4415 14.6306V21.2359C12.404 21.5137 12.496 21.7932 12.6917 21.9939L14.5068 24.1955V24.4859H9.36002V24.1958L11.1751 21.9939C11.3691 21.7929 11.4562 21.5114 11.409 21.2359V13.5982Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIi2);
export default __webpack_public_path__ + "static/media/ii2.f1acd1e08d60df109851c3a02902c7fa.svg";
export { ForwardRef as ReactComponent };